import axios from "axios";
import { useEffect, useState } from "react"
import moment from 'moment';
import "moment/locale/es";
import { useIsMount } from './useIsMount';
import { useLocation } from "react-router-dom";
import { errorHandler } from "../utils/errorHandler";
import { getCourseStartDate } from "../utils/courses-dates";

const PAGE_SIZE = 12;

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export default function useGrandCourses() {
    const [specialtyFilter, setSpecialtyFilter] = useState(null);
    const [academicUnitFilter, setAcademicUnitFilter] = useState(null);
    const [monthFilter, setMonthFilter] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null)
    const [allCourses, setAllCourses] = useState([]);
    const [activePage, setPage] = useState(1);
    const isMount = useIsMount();
    const location = useLocation();

    const filterCourses = (_courses) => {
        if (!_courses) return
        //APPLY FILTERS
        let filteredCourses = _courses;
        if (specialtyFilter) {
            filteredCourses = filteredCourses.filter((course) => course?.specialties?.toUpperCase() === specialtyFilter);
        }
        if (academicUnitFilter) {
            filteredCourses = filteredCourses.filter((course) => course.type.toUpperCase() === academicUnitFilter);
        }
        if (monthFilter) {
            filteredCourses = filteredCourses.filter((course) => {
                if (!course.startDate) return false;
                // .clone() preserva el modo UTC del moment (moment(course.startDate) lo re-proyecta a local)
                return course.startDate.clone().locale("es").format("MMMM").toUpperCase() === monthFilter;
            });
        }
        return filteredCourses;
    }

    const paginatedCourses = (_filteredCourses, _page, _pageSize) => {
        if (!_filteredCourses) return
        //APPLY PAGINATION
        const startIndex = (_page - 1) * _pageSize;
        const endIndex = startIndex + _pageSize;

        return _filteredCourses.slice(startIndex, endIndex);
    };

    const query = useQuery()
    const searchQuery = query.get('query') || ''

    useEffect(() => {
        if (isMount) {
            setIsLoading(true);

            // Filtra webinars outsideCampus y matchea contra la búsqueda
            const matchesSearch = (item, q) => {
                if (item.comercialInformation.outsideCampus) return false;
                const name = item.comercialInformation.name.toLowerCase();
                const type = item.type.toLowerCase();
                const specialty = item.specialties.toLowerCase();
                return name.includes(q) || type.includes(q) || specialty.includes(q);
            };

            // Filtra webinars outsideCampus y agrega startDate (moment UTC) vía util
            const mapWithStartDate = (item) => {
                if (item.comercialInformation.outsideCampus) return null;
                return { ...item, startDate: getCourseStartDate(item) };
            };

            const url = `${process.env.REACT_APP_BACKEND_SERVER}/info/academicUnitsByDivision?division=large`;
            axios
                .get(url)
                .then((res) => {
                    if (searchQuery) {
                        const filteredOpen = res.data.open
                            .filter(item => matchesSearch(item, searchQuery))
                            .map(mapWithStartDate)
                            .filter(Boolean);

                        const filteredClosed = res.data.close
                            .filter(item => matchesSearch(item, searchQuery))
                            .map(mapWithStartDate)
                            .filter(Boolean);

                        return setAllCourses({
                            open: filteredOpen,
                            close: filteredClosed,
                        });
                    }

                    // Sort courses by date
                    const openedCourses = res.data.open.map(mapWithStartDate).filter(Boolean);
                    openedCourses.sort((a, b) => b.startDate - a.startDate);

                    const closedCourses = res.data.close.map(mapWithStartDate).filter(Boolean);
                    closedCourses.sort((a, b) => b.startDate - a.startDate);

                    // Calculate upcoming courses (comparamos en UTC a nivel día)
                    const upcomingCourses = openedCourses
                        .filter(course => course.startDate && course.startDate.isAfter(moment.utc(), 'day'))
                        .sort((a, b) => a.startDate - b.startDate)
                        .slice(0, 3);

                    setAllCourses({
                        open: openedCourses,
                        close: closedCourses,
                        upcomingCourses
                    });
                })
                .catch((err) => {
                    console.log(err)
                    const errorMessage = errorHandler(err)
                    setError(errorMessage)
                })
                .finally(() => setIsLoading(false));
        }
    }, [isMount, searchQuery]);

    useEffect(() => {
        const specialty = query.get("especialidad");
        const academicUnit = query.get("tipo");
        const month = query.get("mes");


        if (specialty) setSpecialtyFilter(specialty.toUpperCase());
        if (academicUnit) setAcademicUnitFilter(academicUnit.toUpperCase());
        if (month) setMonthFilter(month.toUpperCase());
    }, [location.search, query]);

    return {
        setSpecialtyFilter, setAcademicUnitFilter, setMonthFilter, error, isLoading, allCourses, paginatedCourses, filterCourses,activePage, monthFilter, academicUnitFilter, specialtyFilter, setPage, 
PAGE_SIZE
    }
}